import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OnboardingcoreService } from '@tech-services/onboardingcore.service';
import { SessionService } from '@tech-services/session.service';
import { AppConfig } from '@tech-utils/app-config.service';

@Component({
  selector: 'tech-accountconfirmed',
  templateUrl: './accountconfirmed.component.html',
  styleUrls: ['./accountconfirmed.component.scss'],
})
export class AccountconfirmedComponent implements OnInit {
  public isSMSVerification: boolean = false;
  constructor(
    private router: Router,
    public onboardingCoreService: OnboardingcoreService,
    private session: SessionService
  ) {}

  ngOnInit() {
    this.isSMSVerification =
      localStorage.getItem('MainSettings') == 'true'
        ? JSON.parse(localStorage.getItem('SmsVerification'))
        : JSON.parse(AppConfig.settings.SMSVerification);
  }

  public continueRegister() {
    // this.common.setPreviousUrl('signup');
    this.session.operativeInit = 'signup';
    this.router.navigate(['/portfolios']);
  }
}
